module.exports = __webpack_public_path__ + "static/media/background-mask.52bcf56f.svg";